import React, { FormEvent } from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import Geocode from 'react-geocode';
import {
  AbstractControl,
  FieldArray,
  FieldControl,
  FieldGroup,
  FormArray,
  FormBuilder,
  Validators
} from 'react-reactive-form';
import { AppState } from '../../../../store/store.types';
import { NumberInput, TextInput } from '../../../../components/forms/Input';
import Checkbox from '../../../../components/forms/Checkbox';

import { SelectedOption, StatusType } from '../../../../api/api.types';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal';
import {
  AddressModel,
  CarClassModel,
  ContactModel,
  deskEditRoles,
  DeskGroupModel,
  deskLocationTypeOptions,
  DeskModel,
  DeskOpeningExceptionModel,
  DeskOpeningExceptionRequest,
  DeskOpeningModel,
  DeskOpeningRequest,
  DeskOpeningType,
  DeskRequest,
  deskTypeOptions,
  EditDeskRequest,
  ItemGroupType,
  ItemModel,
  Locale,
  localeOptions,
  TranslationModel
} from '../../../../api/core/core.types';
import Breadcrumbs from '../../../../components/breadcrumbs/Breadcrumbs';
import { DeskActionTypes } from '../../types/desk.types';
import { addNewDesk, deleteDesk, editDesk, getDesk, getDeskList } from '../../actions/desk.actions';
import Select from '../../../../components/forms/Select';
import { InputTextArea } from '../../../../components/forms/TextArea';
import StatusLabel from '../../../../components/forms/StatusLabel';
import { ItemPriceModel, MandatoryItemModel, OneWayFeeModel, UnitType } from '../../../../api/pricing/pricing.types';
import { getItemList } from '../../actions/item.actions';
import { getDeskGroupList } from '../../actions/deskgroup.actions';
import { UserModel } from '../../../../api/authentication/authentication.types';
import ExpandButton from '../../../../components/forms/ExpandButton';
import { getLanguageName } from '../../../../helpers/locale.helper';
import GoogleMap from '../../../../components/forms/MapComponent';
import GoogleApi from '../../../../api/google/google.client';
import { AddressComponentTypes, GoogleRequestResponse } from '../../../../api/google/google.types';
import SectionTitle from '../../../../components/forms/SectionTitle';
import {
  addNewDeskOpening,
  deleteDeskOpening,
  editDeskOpening,
  getDeskOpeningList
} from '../../actions/deskopening.actions';
import DeskOpeningTimeline from '../../../../components/forms/DeskOpeningTimeline';
import DeskOpeningOverview from '../../../../components/forms/DeskOpeningOverview';
import DeskOpeningEditModal, { DeskOpeningEditActions } from '../../../../components/modals/DeskOpeningEditModal';
import SelectModal from '../../../../components/modals/SelectModal';
import {
  addNewDeskOpeningException,
  deleteDeskOpeningException,
  editDeskOpeningException,
  getDeskOpeningExceptionList
} from '../../actions/deskopeningexception.actions';
import DeskOpeningExceptionModal from '../../../../components/modals/DeskOpeningExcpetionModal';
import DuplicateDeskOpeningModal, { DuplicateType } from '../../../../components/modals/DuplicateDeskOpeningModal';
import { AdminApi, CoreApi, PricingApi } from '../../../../api/api.apiclient';
import { userCanAccessComponent } from '../../../../helpers/authentication.helper';
import { WithTranslation, withTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import infoIcon from '../../../../assets/img/info-circle.svg';
import { getAllCarClasses } from '../../../core/actions/carClass.actions';
import OneWayFeeTable from '../../../../components/tables/OneWayFeeTable';
import { getOneWayFeeList } from '../../../rates/actions/onewayfee.actions';
import { LoaderBar } from '../../../../components/forms/LoaderBar';
import ItemPriceTable from '../../../../components/tables/ItemPriceTable';
import { ClassifierModel, ClassifierTypes, SupplierModel } from '../../../../api/admin/admin.types';
import { formatDateTime } from '../../../../helpers/date.helper';
import { Link } from 'react-router-dom';
import MandatoryItemSelectModal, {
  MandatoryItemSelectModel
} from '../../../../components/modals/MandatoryItemSelectModal';

interface DeskLocationProps {
  code: string;
}

interface DeskDetailsProps extends RouteComponentProps<DeskLocationProps>, WithTranslation {
  selectedDesk: DeskModel | null;
  getSelectedDesk: (code: string) => Promise<void>;
  editDesk: (code: string, request: EditDeskRequest) => void;
  addNewDesk: (request: DeskRequest) => void;
  deleteDesk: (code: string) => void;
  getDeskOpenings: (deskCode: string) => Promise<void>;
  getDeskOpeningExceptions: (deskCode: string) => Promise<void>;
  getItemList: () => Promise<void>;
  getOneWayFees: () => Promise<void>;
  getDeskGroupList: () => Promise<void>;
  deleteDeskOpening: (id: number, deskCode: string) => void;
  editDeskOpening: (id: number, request: DeskOpeningRequest, deskCode: string) => void;
  addDeskOpening: (request: DeskOpeningRequest, deskCode: string) => void;
  deleteDeskOpeningException: (id: number, deskCode: string) => void;
  editDeskOpeningException: (id: number, request: DeskOpeningExceptionRequest, deskCode: string) => void;
  addDeskOpeningException: (request: DeskOpeningExceptionRequest, deskCode: string) => void;
  getDeskList: () => Promise<void>;
  getSupplierInfo: (code: string) => Promise<void>;
  getAllCarClasses: () => Promise<void>;
  carClasses: CarClassModel[];
  isNewCode?: boolean;
  postSuccess: boolean | null;
  lastFetch: number | null;
  items: ItemModel[];
  oneWayFees: OneWayFeeModel[];
  deskGroups: DeskGroupModel[];
  deskOpenings: DeskOpeningModel[];
  deskOpeningExceptions: DeskOpeningExceptionModel[];
  user: UserModel | null;
  desks: DeskModel[];
  supplier: SupplierModel | null;
}

interface DeskDetailsState {
  filtered: { value: any, id: any }[];
  isDeleteModalOpen: boolean;
  isMandatoryItemModalOpen: boolean;
  isEdit: boolean;
  showNameTranslations: boolean;
  showPickupTranslations: boolean;
  showReturnTranslations: boolean;
  showMap: boolean;
  selectedDeskOpening?: DeskOpeningModel;
  isDeskOpeningModalOpen: boolean;
  deskOpeningAction: DeskOpeningEditActions;
  isEditDeskGroupModalOpen: boolean;
  selectedDeskOpeningException?: DeskOpeningExceptionModel;
  isDeskOpeningExceptionModalOpen: boolean;
  isDuplicateDeskOpeningModalOpen: boolean;
  duplicateType?: DuplicateType;
  duplicatePeriod?: string;
  otaCodes: ClassifierModel[];
  countries: ClassifierModel[];
  isApplyFromModalOpen: boolean;
  filter: {
    returnLocationFilter: {
      value: { value: string, label: string } | undefined;
    };
  };
  filterPositionFromTop: number | undefined;
  loading: boolean;
  itemPrices: ItemPriceModel[];
}

const MONTHS_IN_TIMELINE = 24;

class DeskDetails extends React.Component<DeskDetailsProps, DeskDetailsState> {

  readonly state = {
    filtered: [],
    isDeleteModalOpen: false,
    isMandatoryItemModalOpen: false,
    isEdit: false,
    showNameTranslations: false,
    showPickupTranslations: false,
    showReturnTranslations: false,
    showMap: false,
    selectedDeskOpening: undefined,
    isDeskOpeningModalOpen: false,
    deskOpeningAction: DeskOpeningEditActions.ADD_NEW,
    isEditDeskGroupModalOpen: false,
    selectedDeskOpeningException: undefined,
    isDeskOpeningExceptionModalOpen: false,
    isDuplicateDeskOpeningModalOpen: false,
    duplicateType: undefined,
    duplicatePeriod: undefined,
    otaCodes: [] as ClassifierModel[],
    countries: [] as ClassifierModel[],
    isApplyFromModalOpen: false,
    filter: {
      returnLocationFilter: {
        value: undefined as { value: string, label: string } | undefined
      }
    },
    filterPositionFromTop: undefined,
    loading: false,
    itemPrices: [] as ItemPriceModel[]
  };

  form = FormBuilder.group({
    code: [ '', Validators.required ],
    groupId: [ '', Validators.required ],
    deskType: [ '', Validators.required ],
    deskLocationType: [ '', Validators.required ],
    name: [ '', Validators.required ],
    safRate: [ 0, [ Validators.required, Validators.min(0), Validators.max(100) ] ],
    iataCode: [ '', [ Validators.pattern('^[^a-z]*$'), Validators.minLength(3), Validators.maxLength(3) ] ],
    isWalkInSupported: [ false ],
    isMeetGreetS: [ false ],
    pickupInstructions: [ '' ],
    returnInstructions: [ '' ],
    supplierDeskCode: [ '' ],
    city: [ '', Validators.required ],
    country: [ '', Validators.required ],
    address1: [ '' ],
    address2: [ '' ],
    state: [ '' ],
    timezone: [ '' ],
    postalCode: [ '' ],
    latitude: [ '' ],
    longitude: [ '' ],
    phone: [ '' ],
    emergencyPhone: [ '' ],
    email: [ '' ],
    fax: [ '' ],
    active: [ true ],
    nameTranslations: FormBuilder.array([]),
    pickupTranslations: FormBuilder.array([]),
    returnTranslations: FormBuilder.array([]),
    itemPrices: [ [] ]
  });

  async componentDidMount() {
    const { code } = this.props.match.params;

    if (code) {
      this.setState({ loading: true });
      await this.props.getSelectedDesk(code);
      await this.props.getOneWayFees();
      await this.props.getDeskList();
      await this.props.getItemList();
      await this.props.getDeskGroupList();
      await this.props.getAllCarClasses();
      this.setState({ loading: false });
    }

    if (this.props.deskGroups.length) {
      const defaultGroup = this.props.deskGroups[ 0 ];
      const defaultGroupFormItem = [ { value: String(defaultGroup.id), label: defaultGroup.name } ];
      this.form.controls.groupId.setValue(defaultGroupFormItem[ 0 ].value);
    }

    if (this.props.isNewCode) {
      this.createTranslationForm(this.form.controls.nameTranslations as FormArray, 'nameTranslations');
      this.createTranslationForm(this.form.controls.pickupTranslations as FormArray, 'pickupTranslations');
      this.createTranslationForm(this.form.controls.returnTranslations as FormArray, 'returnTranslations');

      const deskNrs = [ 0 ];

      this.props.desks.forEach((d) => {
        if (d.code.includes(this.props.supplier!.code!)) {
          const extractedDeskNr = d.code.substring(this.props.supplier!.code!.length);
          if (this.isNumeric(extractedDeskNr)) {
            deskNrs.push(Number(extractedDeskNr));
          }
        }
      });

      const maxDeskNr = Math.max(...deskNrs) + 1;

      this.form.controls.code.setValue(this.props.supplier!.code! + maxDeskNr);
    } else if (this.props.selectedDesk) {
      this.assignTranslationToForm(this.props.selectedDesk.nameTranslations, 'nameTranslations');
      this.assignTranslationToForm(this.props.selectedDesk.pickupInstructionsTranslations, 'pickupTranslations');
      this.assignTranslationToForm(this.props.selectedDesk.returnInstructionsTranslations, 'returnTranslations');
    }

    this.form.controls.latitude.valueChanges.subscribe(() => {
      this.onLatLngChange();
    });

    this.form.controls.longitude.valueChanges.subscribe(() => {
      this.onLatLngChange();
    });

    if (this.props.selectedDesk && !this.props.isNewCode) {
      await this.props.getDeskOpenings(code);
      await this.props.getDeskOpeningExceptions(code);
    }

    await AdminApi.Classifiers.listAllClassifiersByType(ClassifierTypes.ITEM_OTA_CODE).then((response) => {
      this.setState({ otaCodes: response });
    });

    await AdminApi.Classifiers.listAllClassifiersByType(ClassifierTypes.COUNTRY).then((response) => {
      this.setState({ countries: response });
    });

    await PricingApi.ItemPrices.listAllItemPricesAllPages({ itemGroupType: ItemGroupType.FEE }).then((response) => {
      this.setState({ itemPrices: response });
    });


    Geocode.setApiKey(`${window.config.googleApiKey}`);
  }

  componentDidUpdate(prevProps: DeskDetailsProps) {
    if ((this.props.isNewCode) && this.props.postSuccess && this.props.selectedDesk) {
      this.props.history.push(`/setup/desks/${this.props.selectedDesk.code}/view`);
    }

    if (this.props.selectedDesk && (!prevProps.selectedDesk || this.props.selectedDesk !== prevProps.selectedDesk)) {
      this.updateFormValue();

      this.assignTranslationToForm(this.props.selectedDesk.nameTranslations, 'nameTranslations');
      this.assignTranslationToForm(this.props.selectedDesk.pickupInstructionsTranslations, 'pickupTranslations');
      this.assignTranslationToForm(this.props.selectedDesk.returnInstructionsTranslations, 'returnTranslations');
    }
  }

  getOneWayFees = async () => {
    await this.props.getOneWayFees();
    this.setState({ loading: false });
  };

  onDeleteConfirm = () => {
    const { code } = this.props.match.params;
    this.props.deleteDesk(code);

    this.props.history.push('/setup/desks/');
  };

  onSubmit = (e?: FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    const form = this.form.controls;

    const countryValue = form.country.value.toLowerCase();
    if (!this.state.countries.find((country) => country.code.toLowerCase() === countryValue || country.name.toLowerCase() === countryValue || country.stringValue.toLowerCase() === countryValue)) {
      form.country.setErrors({ 'incorrect': true });
    }
    this.form.markAsSubmitted();
    if (this.form.invalid) {
      return;
    }

    const nameTranslations: TranslationModel[] = this.getTranslationsArray(this.form.controls.nameTranslations as FormArray);
    const pickupInstructionsTranslations: TranslationModel[] = this.getTranslationsArray(this.form.controls.pickupTranslations as FormArray);
    const returnInstructionsTranslations: TranslationModel[] = this.getTranslationsArray(this.form.controls.returnTranslations as FormArray);

    if (this.props.selectedDesk && !this.props.isNewCode) {
      const addressRequest: AddressModel = {
        city: form.city.value,
        country: form.country.value,
        address1: form.address1.value,
        address2: form.address2.value,
        state: form.state.value,
        timezone: form.timezone.value,
        postalCode: form.postalCode.value,
        latitude: form.latitude.value,
        longitude: form.longitude.value
      };

      const contactRequest: ContactModel = {
        phone: form.phone.value,
        emergencyPhone: form.emergencyPhone.value,
        email: form.email.value,
        fax: form.fax.value
      };

      const request: EditDeskRequest = {
        ...this.props.selectedDesk as any,
        groupId: form.groupId.value,
        deskType: form.deskType.value,
        deskLocationType: form.deskLocationType.value,
        name: form.name.value,
        safRate: this.form.controls.safRate.value / 100,
        iataCode: form.iataCode.value?.length ? form.iataCode.value : null,
        isWalkInSupported: form.isWalkInSupported.value === undefined ? false : form.isWalkInSupported.value,
        isMeetGreetSupported: form.isMeetGreetSupported === undefined || form.isMeetGreetSupported.value === undefined ? false : form.isMeetGreetSupported.value,
        pickupInstructions: form.pickupInstructions.value,
        returnInstructions: form.returnInstructions.value,
        supplierDeskCode: form.supplierDeskCode.value,
        statusType: form.active.value ? StatusType.ACTIVE : StatusType.INACTIVE,
        address: addressRequest,
        contact: contactRequest,
        nameTranslations,
        pickupInstructionsTranslations,
        returnInstructionsTranslations,
        itemPrices: this.getItemPricesFromForm()
      };
      const { code } = this.props.match.params;

      this.props.editDesk(code, request);
      this.setState({ isEdit: false });
    } else {
      const addressRequest: AddressModel = {
        city: form.city.value,
        country: form.country.value,
        address1: form.address1.value,
        address2: form.address2.value,
        state: form.state.value,
        timezone: form.timezone.value,
        postalCode: form.postalCode.value,
        latitude: form.latitude.value,
        longitude: form.longitude.value
      };

      const contactRequest: ContactModel = {
        phone: form.phone.value,
        emergencyPhone: form.emergencyPhone.value,
        email: form.email.value,
        fax: form.fax.value
      };

      const request: DeskRequest = {
        code: form.code.value,
        groupId: form.groupId.value,
        deskType: form.deskType.value,
        deskLocationType: form.deskLocationType.value,
        name: form.name.value,
        safRate: this.form.controls.safRate.value / 100,
        iataCode: form.iataCode.value?.length ? form.iataCode.value : null,
        isWalkInSupported: form.isWalkInSupported.value === undefined ? false : form.isWalkInSupported.value,
        isMeetGreetSupported: form.isMeetGreetSupported.value === undefined ? false : form.isMeetGreetSupported.value,
        pickupInstructions: form.pickupInstructions.value,
        returnInstructions: form.returnInstructions.value,
        supplierDeskCode: form.supplierDeskCode.value,
        statusType: form.active.value ? StatusType.ACTIVE : StatusType.INACTIVE,
        address: addressRequest,
        contact: contactRequest,
        nameTranslations,
        pickupInstructionsTranslations,
        returnInstructionsTranslations,
        itemPrices: []
      };

      this.props.addNewDesk(request);
    }
  };

  getItemPricesFromForm = () => {
    const itemPrices: MandatoryItemModel[] = [];
    this.form.controls.itemPrices.value.forEach((ip: { value: string; label: string, collectedByBroker: boolean }) => {
      const mandatoryItemPrice: MandatoryItemModel = {
        itemPriceId: Number(ip.value),
        collectedByBroker: ip.collectedByBroker
      };
      itemPrices.push(mandatoryItemPrice);
    });

    return itemPrices;
  };

  isNumeric(str: string) {
    return !isNaN(parseFloat(str));
  }

  getTranslationsArray = (form: FormArray) => {
    const translations: TranslationModel[] = [];

    form.value.forEach((v: { language: Locale; translation: string; code: string }) => {
      const translation: TranslationModel = {
        language: v.language,
        value: v.translation
      };

      translations.push(translation);
    });

    return translations;
  };

  onLocationSelect = (lat: number, long: number) => {
    this.form.patchValue({ latitude: lat, longitude: long });
    this.getAddressFromGeocode(String(lat), String(long));
  };

  onNameTranslationsClick = () => {
    this.setState({ showNameTranslations: !this.state.showNameTranslations });
  };

  onPickupTranslationsClick = () => {
    this.setState({ showPickupTranslations: !this.state.showPickupTranslations });
  };

  onReturnTranslationsClick = () => {
    this.setState({ showReturnTranslations: !this.state.showReturnTranslations });
  };

  onShowMapClick = async () => {
    this.setState({ showMap: !this.state.showMap });
  };


  getItemPriceName = (itemId: number) => {

    if (this.props.items) {
      const item = this.props.items.find((i) => i.id === itemId);
      if (item) {
        return item.name;
      }
    }

    return String(itemId);
  };

  getLabel = (list: any[], value: string) => {
    const obj = list.find((select) => select.value === value);
    if (obj) {
      return obj.label;
    }

    return value;
  };

  getTimezone = () => {
    GoogleApi.Google.getTimezone(this.form.controls.latitude.value, this.form.controls.longitude.value).then((response) => {
      if (response && response.status === GoogleRequestResponse.OK) {
        this.form.patchValue({ timezone: response.timeZoneId });
      }
    });
  };

  onCancel = () => {
    if (this.props.isNewCode) {
      this.props.history.push('/setup/desks/');
    } else {
      this.updateFormValue();
      this.setState({ isEdit: false });
    }
  };

  onEdit = () => {
    this.updateFormValue();
    this.setState({ isEdit: true });
  };

  getDeskGroupOptions = () => {
    const options: { value: string; label: string }[] = [];
    this.props.deskGroups.forEach((g: DeskGroupModel) => {
      options.push({ value: g.id ? String(g.id) : '1', label: g.name });
    });

    return options;
  };

  getDeskOptions = () => {
    const options: { value: string; label: string }[] = [];
    this.props.desks.forEach((d: DeskModel) => {
      options.push({ value: d.code, label: d.name });
    });

    return options;
  };

  getGroup() {
    const desk = this.props.selectedDesk;
    if (desk) {
      const group = this.props.deskGroups.find((g) => g.id === desk.group.id);

      if (group) {
        return [ { value: String(group.id), label: group.name } ];
      }
    }

    if (this.props.deskGroups.length) {
      const defaultGroup = this.props.deskGroups[ 0 ];
      return [ { value: String(defaultGroup.id), label: defaultGroup.name } ];
    }
    return [] as { value: string; label: string }[];
  }

  editDeskGroup = (value: any) => {
    this.form.patchValue({ groupId: value.value });
    this.setState({ isEditDeskGroupModalOpen: false });

    this.onSubmit();
  };

  editItemPrices = async (values: any) => {
    this.setState({ isMandatoryItemModalOpen: false });
    this.form.patchValue({
      itemPrices: values,
      groupId: this.props.selectedDesk?.group.id ?? this.form.controls.groupId.value[ 0 ].value
    });

    this.onSubmit();
  };

  assignTranslationToForm = (translations: TranslationModel[], name: string) => {
    this.form.controls[ name ] = FormBuilder.array([]);
    const form = this.form.controls[ name ] as FormArray;

    translations.forEach((translation) => {
      form.push(FormBuilder.group({
        language: [ translation.language ],
        code: [ `${name} ${translation.language}` ],
        translation: [ translation.value ]
      }));
    });
  };

  createTranslationForm = (form: FormArray, type: string) => {
    localeOptions.forEach((locale: { value: Locale; label: string }) => {

      form.push(FormBuilder.group({
        language: [ locale.value ],
        code: [ `${type} ${locale.value}` ],
        translation: [ '' ]
      }));
    });
  };

  onDeskOpeningDelete = () => {
    const deskOpening: any = this.state.selectedDeskOpening;
    if (deskOpening && this.props.selectedDesk) {
      this.props.deleteDeskOpening(deskOpening.id, this.props.selectedDesk.code);
      this.setState({ selectedDeskOpening: undefined });
      this.props.getDeskOpenings(this.props.selectedDesk.code);
    }
  };

  onDeskOpeningExceptionDelete = () => {
    const exception: any = this.state.selectedDeskOpeningException;
    if (exception && this.props.selectedDesk) {
      this.props.deleteDeskOpeningException(exception.id, this.props.selectedDesk.code);
      this.setState({ selectedDeskOpeningException: undefined });
      this.props.getDeskOpeningExceptions(this.props.selectedDesk.code);
    }
  };

  onAddNewDeskOpening = async (request: DeskOpeningRequest) => {
    if (this.props.selectedDesk) {
      await this.props.addDeskOpening(request, this.props.selectedDesk.code);
      this.props.getDeskOpenings(this.props.selectedDesk.code);
    }
  };

  onEditDeskOpeningRequest = async (request: DeskOpeningRequest) => {
    const deskOpening: any = this.state.selectedDeskOpening;
    if (deskOpening && this.props.selectedDesk) {
      await this.props.editDeskOpening(deskOpening.id, request, this.props.selectedDesk.code);
      this.props.getDeskOpenings(this.props.selectedDesk.code);
      this.setState({ selectedDeskOpening: undefined });
    }
  };

  onAddNewDeskOpeningException = async (request: DeskOpeningExceptionRequest) => {
    if (this.props.selectedDesk) {
      await this.props.addDeskOpeningException(request, this.props.selectedDesk.code);
      this.props.getDeskOpeningExceptions(this.props.selectedDesk.code);
    }
  };

  onEditDeskOpeningException = async (request: DeskOpeningExceptionRequest) => {
    const exceptions: any = this.state.selectedDeskOpeningException;
    if (exceptions && this.props.selectedDesk) {
      await this.props.editDeskOpeningException(exceptions.id, request, this.props.selectedDesk.code);
      this.props.getDeskOpeningExceptions(this.props.selectedDesk.code);
      this.setState({ selectedDeskOpeningException: undefined });
    }
  };

  onEditDeskOpeningClick = () => {
    this.setState({
      isDeskOpeningModalOpen: true,
      deskOpeningAction: DeskOpeningEditActions.EDIT
    });
  };

  onDuplicateDeskOpeningClick = () => {
    const deskOpening = this.state.selectedDeskOpening as unknown as DeskOpeningModel;

    if (deskOpening) {
      this.setState({
        isDuplicateDeskOpeningModalOpen: true,
        duplicatePeriod: `${deskOpening.validFrom} - ${deskOpening.validTo}`,
        duplicateType: DuplicateType.DESK_OPENING
      });
    }
  };

  onDeleteDeskOpeningClick = () => {
    this.onDeskOpeningDelete();
    const { code } = this.props.match.params;
    if (this.props.selectedDesk) this.props.getDeskOpenings(code);
  };

  onEditDeskOpeningExceptionClick = () => {
    this.setState({
      isDeskOpeningExceptionModalOpen: true,
      deskOpeningAction: DeskOpeningEditActions.EDIT
    });
  };

  onDuplicateDeskOpeningExceptionClick = () => {
    const deskOpeningException = this.state.selectedDeskOpeningException as unknown as DeskOpeningExceptionModel;

    if (deskOpeningException) {
      this.setState({
        isDuplicateDeskOpeningModalOpen: true,
        duplicatePeriod: deskOpeningException.date,
        duplicateType: DuplicateType.DESK_OPENING_EXCEPTION
      });
    }
  };

  onDeleteDeskOpeningExceptionClick = () => {
    this.onDeskOpeningExceptionDelete();
    const { code } = this.props.match.params;
    if (this.props.selectedDesk) this.props.getDeskOpeningExceptions(code);
  };

  onDeskOpeningModalSubmit = (request: DeskOpeningRequest, action: DeskOpeningEditActions) => {
    this.setState({ isDeskOpeningModalOpen: false });
    if (action === DeskOpeningEditActions.EDIT) {
      this.onEditDeskOpeningRequest(request);
    } else this.onAddNewDeskOpening(request);
  };

  onDeskOpeningExceptionModalSubmit = (request: DeskOpeningExceptionRequest, action: DeskOpeningEditActions) => {
    this.setState({ isDeskOpeningExceptionModalOpen: false });
    if (action === DeskOpeningEditActions.EDIT) {
      this.onEditDeskOpeningException(request);
    } else this.onAddNewDeskOpeningException(request);
  };

  onDuplicate = async (duration: { validFrom: string; validTo: string; type: DuplicateType }) => {
    this.setState({ isDuplicateDeskOpeningModalOpen: false });
    if (duration.type === DuplicateType.DESK_OPENING) {
      const deskOpening = this.state.selectedDeskOpening;

      if (this.props.selectedDesk && deskOpening) {
        await this.props.addDeskOpening(this.deskOpeningToRequest(deskOpening, duration.validFrom, duration.validTo), this.props.selectedDesk.code);
        await this.props.getDeskOpenings(this.props.selectedDesk.code);
        this.setState({ selectedDeskOpening: undefined });
      }
    }

    if (duration.type === DuplicateType.DESK_OPENING_EXCEPTION) {
      const deskOpeningException = this.state.selectedDeskOpeningException;

      if (this.props.selectedDesk && deskOpeningException) {
        await this.props.addDeskOpeningException(this.deskOpeningExceptionToRequest(deskOpeningException, duration.validFrom), this.props.selectedDesk.code);
        await this.props.getDeskOpeningExceptions(this.props.selectedDesk.code);
        this.setState({ selectedDeskOpeningException: undefined });
      }
    }
  };

  deskOpeningToRequest = (deskOpening: DeskOpeningModel, validFrom?: string, validTo?: string) => {
    const request: DeskOpeningRequest = {
      validFrom: validFrom ?? deskOpening.validFrom,
      validTo: validTo ?? deskOpening.validTo,
      openHours: deskOpening.openHours,
      statusType: deskOpening.statusType,
      daysClosed: deskOpening.daysClosed,
      returnOutOfHoursType: deskOpening.returnOutOfHoursType,
      pickupOutOfHoursType: deskOpening.pickupOutOfHoursType,
      deskOpeningType: DeskOpeningType.STANDARD
    };

    return request;
  };

  deskOpeningExceptionToRequest = (deskOpeningException: DeskOpeningExceptionModel, date?: string) => {
    const request: DeskOpeningExceptionRequest = {
      date: date ?? deskOpeningException.date,
      returnOutOfHoursType: deskOpeningException.returnOutOfHoursType,
      pickupOutOfHoursType: deskOpeningException.pickupOutOfHoursType,
      openHoursExceptions: deskOpeningException.openHoursExceptions,
      isClosed: deskOpeningException.isClosed,
      statusType: deskOpeningException.statusType
    };

    return request;
  };

  updateFormValue = () => {
    if (!this.props.selectedDesk) {
      return;
    }
    this.form.patchValue({
      code: this.props.selectedDesk.code,
      groupId: this.props.selectedDesk.group.id,
      deskType: this.props.selectedDesk.deskType,
      deskLocationType: this.props.selectedDesk.deskLocationType,
      name: this.props.selectedDesk.name,
      safRate: Math.round(this.props.selectedDesk.safRate * 100),
      iataCode: this.props.selectedDesk.iataCode,
      isWalkInSupported: this.props.selectedDesk.isWalkInSupported,
      isMeetGreetSupported: this.props.selectedDesk.isMeetGreetSupported,
      pickupInstructions: this.props.selectedDesk.pickupInstructions,
      returnInstructions: this.props.selectedDesk.returnInstructions,
      supplierDeskCode: this.props.selectedDesk.supplierDeskCode,
      city: this.props.selectedDesk.address.city,
      country: this.props.selectedDesk.address.country,
      address1: this.props.selectedDesk.address.address1,
      address2: this.props.selectedDesk.address.address2,
      state: this.props.selectedDesk.address.state,
      timezone: this.props.selectedDesk.address.timezone,
      postalCode: this.props.selectedDesk.address.postalCode,
      latitude: this.props.selectedDesk.address.latitude,
      longitude: this.props.selectedDesk.address.longitude,
      phone: this.props.selectedDesk.contact.phone,
      emergencyPhone: this.props.selectedDesk.contact.emergencyPhone,
      email: this.props.selectedDesk.contact.email,
      fax: this.props.selectedDesk.contact.fax,
      active: this.props.selectedDesk.statusType === StatusType.ACTIVE,
      itemPrices: this.getItemPrices()
    });
  };

  getItemPrices = () => {
    const itemPrices = [] as MandatoryItemSelectModel[];
    let index = 0;
    if (this.props.selectedDesk) {
      this.props.selectedDesk.itemPrices.forEach((mip) => {
        const itemPrice = this.state.itemPrices.find((ip) => ip.id === mip.itemPriceId);
        itemPrices.push(itemPrice ? {
          value: String(itemPrice.id),
          label: this.getItemPriceName(itemPrice.coreItemId),
          isNew: false,
          collectedByBroker: mip.collectedByBroker,
          index: index
        } : {
          value: String(mip.itemPriceId),
          label: String(mip.itemPriceId),
          isNew: false,
          collectedByBroker: mip.collectedByBroker,
          index: index
        });
        index += 1;
      });
    }
    return itemPrices;
  };

  onLocationSearch = async (locationObject: any) => {
    const address = locationObject.label;
    const latLng = await this.getLatLngFromGecode(address);
    if (latLng) this.getAddressFromGeocode(latLng.lat, latLng.lng);
  };

  patchField = (option: SelectedOption, field: string) => {
    this.form.patchValue({ [ field ]: option.value });
  };

  getItemOptions = () => {
    const options: MandatoryItemSelectModel[] = [];
    if (this.state.itemPrices) {
      let index = 0;
      this.state.itemPrices.forEach((ip) => {
        const item = this.props.items.find((i) => i.id === ip.coreItemId);
        let label = String(ip.id);
        if (item) {
          label = `${item.name} (${ip.price}`;
          if (ip.unitType === UnitType.PER_CENT) label = label.concat('%)');
          else {
            if (this.props.supplier) label = label.concat(` ${this.props.supplier.baseCurrencyCode} `);
            if (ip.unitType === UnitType.FIXED) label = label.concat('/ RENTAL)');
            else label = label.concat('/ DAY)');
          }
        }
        if (item && item.itemGroupType === ItemGroupType.FEE) options.push({
          value: String(ip.id),
          label: label,
          isNew: true,
          collectedByBroker: true,
          index: index
        });
        index += 1;
      });
    }

    return options;
  };

  getLatLngFromGecode = async (address: string) => {
    const response = await Geocode.fromAddress(address);
    const { lat, lng } = response.results[ 0 ].geometry.location;
    this.form.patchValue({
      latitude: lat,
      longitude: lng
    });

    return { lat, lng };
  };

  splitAddressToForm = (addressComponents: any) => {
    let number: string | undefined;
    let route: string | undefined;
    let city: string | undefined;
    let state: string | undefined;
    let country: string | undefined;

    addressComponents.forEach((element: any) => {
      element.address_components.forEach((c: any) => {
        if (!number && c.types.includes(AddressComponentTypes.NUMBER)) {
          number = c.long_name;
        } else if (!route && c.types.includes(AddressComponentTypes.ROUTE)) {
          route = c.long_name;
        } else if (!city && c.types.includes(AddressComponentTypes.CITY)) {
          city = c.long_name;
        } else if (!state && c.types.includes(AddressComponentTypes.STATE)) {
          state = c.long_name;
        } else if (!country && c.types.includes(AddressComponentTypes.COUNTRY)) {
          country = c.short_name;
        }
      });
    });

    this.form.patchValue({
      address1: `${route} ${number}.`,
      city: city ?? '',
      state: state ?? '',
      country: country ?? ''
    });

  };

  getAddressFromGeocode = (lat: string, lng: string) => {
    Geocode.fromLatLng(lat, lng).then(
      (response) => {
        const addressComponents = response.results;
        this.splitAddressToForm(addressComponents);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  onLatLngChange = () => {
    if (this.form.controls.longitude.value && this.form.controls.latitude.value && this.state.isEdit) {
      this.getTimezone();
      this.getAddressFromGeocode(this.form.controls.latitude.value, this.form.controls.longitude.value);
    }
  };

  sortDeskOpenings = () => {
    return this.props.deskOpenings.sort((a, b) => {
      if (dayjs(a.validFrom).isBefore(dayjs(b.validFrom))) {
        return -1;
      }

      return 1;
    });
  };

  onDeskOpeningSelect = (id: number) => {
    this.setState({
      selectedDeskOpeningException: undefined,
      selectedDeskOpening: this.props.deskOpenings.find((d) => d.id === id)
    });
  };

  onDeskOpeningExceptionSelect = (id: number) => {
    this.setState({
      selectedDeskOpeningException: this.props.deskOpeningExceptions.find((d) => d.id === id),
      selectedDeskOpening: undefined
    });
  };

  applyOpeningsFromOtherDesk = async (value: { value: string; label: string }) => {
    if (this.props.selectedDesk) {
      await CoreApi.Desks.applyDeskOpeningsFromOtherDesk({ openingsOriginDeskCode: value.value }, this.props.selectedDesk.code);
      this.props.getDeskOpenings(this.props.selectedDesk.code);
      this.props.getDeskOpeningExceptions(this.props.selectedDesk.code);

      this.setState({ isApplyFromModalOpen: false });
    }
  };

  handleFilterValChange = () => {
    const filter = this.state.filter;
    this.setState({
      filtered: [
        { value: { value: this.props.selectedDesk?.code }, id: 'pickupDeskCode' },
        { value: filter.returnLocationFilter.value, id: 'returnDeskCode' }
      ]
    });
  };

  dropdownChange = (newValue: any, field: string) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [ field ]: {
          value: newValue
        }
      }
    }, () => {
      this.handleFilterValChange();
    });
  };


  render() {
    if (!this.props.isNewCode && !this.props.selectedDesk) {
      return null;
    }

    const { t } = this.props;

    const desk = this.props.selectedDesk;

    const showForm = this.state.isEdit || this.props.isNewCode;
    let canEdit: boolean;

    if (showForm) {
      canEdit = false;
    } else {
      canEdit = true;
    }

    const filtered = [
      { value: { value: this.props.selectedDesk?.code }, id: 'pickupDeskCode' },
      { value: this.state.filter.returnLocationFilter.value, id: 'returnDeskCode' }
    ];

    const returnDesks = this.state.filter.returnLocationFilter.value?.value ? this.props.desks.filter((returnDesk: DeskModel) => returnDesk.code === this.state.filter.returnLocationFilter.value?.value) : this.props.desks;

    return (
      <main>
        <Breadcrumbs
          items={
            [
              { path: '/setup', label: t('m1.setup') },
              { path: '/setup/desks', label: t('m2.desks') },
              {
                path: null,
                label: this.props.isNewCode ? 'New code' : this.props.selectedDesk && this.props.selectedDesk.code || ''
              }
            ]
          }
        />
        <div className="page-content">
          <div className="row justify-content-end">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h1 className="mb-0">{`${!this.props.isNewCode ? desk?.name : 'Add new desk'}`}</h1>
            </div>
          </div>
        </div>
        {!this.props.isNewCode && !this.state.isEdit && desk && (
          <div className="page-content">
            {this.props.user && userCanAccessComponent(this.props.user, deskEditRoles) ? (
              <SectionTitle
                title={t('section_title.desk.details').toUpperCase()}
                showButton
                buttonName={t('b.edit_Generic edit button').toUpperCase()}
                onEditClick={() => this.onEdit()}
                showDeleteButton
                deleteButtonName={t('b.delete_Generic delete button').toUpperCase()}
                onDeleteClick={() => this.setState({ isDeleteModalOpen: true })}
              />
            ) : (
              <SectionTitle
                title={t('section_title.desk.details').toUpperCase()}
              />
            )}
            <div className="d-flex">
              <div className="col-7 align-content-start">
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label className="col-2 d-flex align-items-center justify-content-end">{t('l.desk.status')} </label>
                  <div className="col-6 d-flex align-items-center justify-content-start"><StatusLabel
                    status={desk.statusType}/></div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label className="col-2 d-flex align-items-center justify-content-end">{t('l.desk.code')} </label>
                  <div className="col-6 d-flex align-items-center justify-content-start">{desk.code}</div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label
                    className="col-2 d-flex align-items-center justify-content-end">{t('l.desk.location_type')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{this.getLabel(deskLocationTypeOptions, desk.deskLocationType)}</div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label className="col-2 d-flex align-items-center justify-content-end">{t('l.desk.type')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{this.getLabel(deskTypeOptions, desk.deskType)}</div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label className="col-2 d-flex align-items-center justify-content-end">{t('l.desk.iata')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{desk.iataCode}</div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label
                    className="col-2 d-flex align-items-center justify-content-end">{t('l.desk.airport_tax')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{this.form.controls.safRate.value}</div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.supplier_ref_code')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{desk.supplierDeskCode}</div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.desk_group')} </label>
                  <div className="col-6 d-flex align-items-center justify-content-start">
                    <div className="mr-1">{desk.group.name}</div>
                    {this.props.user && userCanAccessComponent(this.props.user, deskEditRoles) && (
                      <ExpandButton className="btn btn-text-only  ml-2" text="Edit" onClick={() => {
                        this.setState({ isEditDeskGroupModalOpen: true });
                      }}></ExpandButton>
                    )}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end mt-1">
                  <label
                    className="col-4 d-flex align-items-start justify-content-end">{t('l.desk.pickup_instructions')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.pickupInstructions}`}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-end mt-1">
                  <label
                    className="col-4 d-flex align-items-start justify-content-end">{t('l.desk.return_instructions')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.returnInstructions}`}
                  </div>
                </div>
              </div>
              <div className="col-5 align-content-start justify-content-end">
                <div className="d-flex col-12 row info-container justify-content-start">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('section_title.address')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.address.address1}, ${desk.address.city}, ${desk.address.country}`}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-start">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.address.lat_long')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.address.latitude}, ${desk.address.longitude}`}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-start">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.phone')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.contact.phone}`}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-start">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.emegency_phone')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.contact.emergencyPhone}`}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-start">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.email')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.contact.email}`}
                  </div>
                </div>
                <div className="d-flex col-12 row info-container justify-content-start">
                  <label
                    className="col-4 d-flex align-items-center justify-content-end">{t('l.desk.fax')} </label>
                  <div
                    className="col-6 d-flex align-items-center justify-content-start">{`${desk.contact.fax}`}
                  </div>
                </div>

              </div>
            </div>
            <div className="d-flex row align-items-center justify-content-between mt-2">
              <label className="section-header">{t('section_title.desk.opening_hours').toUpperCase()}</label>
              <div className="horizontal-dividing-line"></div>
              <div className="justify-content-end to-front">
                {this.props.user && userCanAccessComponent(this.props.user, deskEditRoles) && (
                  <>
                    <button type="button" className="btn btn-outline-secondary mr-2"
                            onClick={() => {
                              this.setState({
                                isApplyFromModalOpen: true,
                                selectedDeskOpeningException: undefined,
                                selectedDeskOpening: undefined
                              });
                            }}>{t('b.copy_from_other_desk').toUpperCase()}</button>
                    <button type="button" className="btn btn-primary mr-2" onClick={() => {
                      this.setState({
                        isDeskOpeningExceptionModalOpen: true,
                        selectedDeskOpeningException: undefined
                      });
                    }}>{t('b.add_new_holiday').toUpperCase()}</button>
                    <button type="button" className="btn btn-primary mr-2" onClick={() => {
                      this.setState({ isDeskOpeningModalOpen: true, selectedDeskOpening: undefined });
                    }}>{t('b.add_new_period').toUpperCase()}</button>
                  </>
                )}
              </div>
            </div>
            <div className="col-12 mt-1">
              <div className="timeline-container mt-2 pt-2 pb-2">
                <DeskOpeningTimeline
                  startDate={dayjs().startOf('month').format('YYYY-MM')}
                  endDate={dayjs().startOf('day').add(MONTHS_IN_TIMELINE, 'M').format('YYYY-MM')}
                  deskOpenings={this.sortDeskOpenings()}
                  deskOpeningExceptions={this.props.deskOpeningExceptions}
                  selectedDeskOpeningException={this.state.selectedDeskOpeningException}
                  selectedDeskOpening={this.state.selectedDeskOpening}
                  onDeskOpeningClick={(id: number) => this.onDeskOpeningSelect(id)}
                  onDeskOpeningExceptionClick={(id: number) => this.onDeskOpeningExceptionSelect(id)}
                />
                <div className="page-content mt-2 d-flex justify-content-center">
                  {this.state.selectedDeskOpening && (
                    <DeskOpeningOverview
                      deskOpening={this.state.selectedDeskOpening}
                      onEdit={() => this.onEditDeskOpeningClick()}
                      onDuplicate={() => this.onDuplicateDeskOpeningClick()}
                      onDelete={() => this.onDeleteDeskOpeningClick()}
                      showButtons={this.props.user && userCanAccessComponent(this.props.user, deskEditRoles)}
                    />
                  )}
                  {this.state.selectedDeskOpeningException && (
                    <DeskOpeningOverview
                      deskOpeningException={this.state.selectedDeskOpeningException}
                      onEdit={() => this.onEditDeskOpeningExceptionClick()}
                      onDuplicate={() => this.onDuplicateDeskOpeningExceptionClick()}
                      onDelete={() => this.onDeleteDeskOpeningExceptionClick()}
                      showButtons={this.props.user && userCanAccessComponent(this.props.user, deskEditRoles)}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="mt-2">
              {this.props.user && userCanAccessComponent(this.props.user, deskEditRoles) ? (
                <SectionTitle
                  title={t('section_title.desk.fees').toUpperCase()}
                  showButton
                  buttonName={t('b.desk.edit_fees_button to open add/remove fees functionality').toUpperCase()}
                  onEditClick={() => this.setState({ isMandatoryItemModalOpen: true })}
                />
              ) : (
                <SectionTitle
                  title={t('section_title.desk.fees').toUpperCase()}
                />
              )}
              {this.props.selectedDesk && !this.state.loading ? (
                <div className="col-12 mt-1">
                  <div className="fees-container p-1">
                    <div className="fees-container-body p-1 m-2">
                      <ItemPriceTable
                        itemPrices={this.state.itemPrices}
                        carClasses={this.props.carClasses}
                        items={this.props.items}
                        itemOtaCodes={this.state.otaCodes}
                        formItemPrices={this.form.controls.itemPrices.value}
                        currency={this.props.supplier?.baseCurrencyCode}
                      />
                    </div>
                  </div>
                </div>) : ''
              }
            </div>
            <div className="mt-2">
              <SectionTitle
                title={t('section_title.desk.one_way_fees').toUpperCase()}
              />
              <div className="col-12 mt-1">
                <div className="fees-container p-1">
                  <form
                    className="container-fluid filter-container form-group form-inline d-flex justify-content-between">
                    <div className="d-flex row ml-1">
                      <Select
                        value={this.state.filter.returnLocationFilter.value}
                        equalWidthElement
                        className="mr-1"
                        elWidth={240}
                        placeholder={t('ph.filter.one_way_fees.by_return_desk')}
                        options={this.props.desks.map((d) => ({ label: `${d.name} (${d.code})`, value: d.code }))}
                        onChange={(val) => this.dropdownChange(val, 'returnLocationFilter')}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        label="returnLocation"
                      />
                    </div>
                  </form>
                  {this.props.desks && this.props.oneWayFees && (
                    <div className="fees-container-body p-1 m-2">
                      {this.state.loading ? <LoaderBar/> : ''}
                      <OneWayFeeTable
                        oneWayFees={this.props.oneWayFees}
                        waitingForResponse={(status: boolean) => this.setState({ loading: status })}
                        getOneWayFees={() => this.getOneWayFees()}
                        pickupDesks={this.props.selectedDesk ? [ this.props.selectedDesk ] : []}
                        returnDesks={returnDesks.filter(pickupDesk => pickupDesk.code !== this.props.selectedDesk?.code)}
                        supplierInfo={this.props.supplier}
                        canEdit={this.props.user !== null && userCanAccessComponent(this.props.user, deskEditRoles) && !this.state.loading}/>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-2">
              <SectionTitle title={t('section_title.audit').toUpperCase()}/>
              <div className="d-flex">
                <div className="col-8">
                  <div className="d-flex row info-container">
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">{t('l.car_model.created_by')} </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      {desk.createdBy ? desk.createdBy : 'System'}{desk.createdAt ? ` @ ${formatDateTime(desk.createdAt)}` : ''}
                    </div>
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">{t('l.car_model.modified_by')} </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      {desk.modifiedBy ? desk.modifiedBy : 'System'}{desk.modifiedAt ? ` @ ${formatDateTime(desk.modifiedAt)}` : ''}
                    </div>
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">Audit log </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      <Link to={`/setup/desks/${desk.code}/audit`}
                            className="btn btn-text-only"
                            target="_blank"
                            rel="noopener noreferrer">
                        {t('b.car_model.view_audit_log')}
                      </Link>
                    </div>
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">Opening audit log </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      <Link to={`/setup/desks/${desk.code}/desk-openings/audit`}
                            className="btn btn-text-only"
                            target="_blank"
                            rel="noopener noreferrer">
                        {t('b.car_model.view_audit_log')}
                      </Link>
                    </div>
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">Holiday opening audit log </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      <Link to={`/setup/desks/${desk.code}/holidays/audit`}
                            className="btn btn-text-only"
                            target="_blank"
                            rel="noopener noreferrer">
                        {t('b.car_model.view_audit_log')}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showForm && (
          <FieldGroup
            strict={false}
            control={this.form}
            render={() => (
              <form className="form-horizontal page-content" onSubmit={(e) => this.onSubmit(e)}>
                <hr/>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.status')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center">
                    <FieldControl
                      name="active"
                      render={(props) => <Checkbox {...props} id="statusField" className="mt-1">Active</Checkbox>}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.name')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="name"
                      render={TextInput}
                    />
                  </div>
                  <div className="col-1 padding-zero">
                    <ExpandButton className="btn btn-text-only  pl-1" text="translations"
                                  onClick={this.onNameTranslationsClick}></ExpandButton>
                  </div>
                </div>
                {this.state.showNameTranslations && (
                  <>
                    <FieldArray
                      strict={false}
                      name="nameTranslations"
                      render={({ controls }: any) => controls.map((control: AbstractControl) => (
                        <FieldGroup
                          strict={false}
                          key={control.value.code}
                          control={control}
                          render={() => (
                            <div className="form-group d-flex">
                              <div className="col-4 d-flex align-items-center justify-content-end">
                                <label>{getLanguageName(control.value.language)}</label>
                              </div>
                              <div className="col-3 d-flex align-items-center justify-content-start edit-form-input"
                                   key={control.value.code}>
                                <FieldControl
                                  strict={false}
                                  name="translation"
                                  key={control.value.code}
                                  render={(props) => <TextInput {...props} id={control.value.code}></TextInput>}
                                />
                              </div>
                            </div>
                          )}
                        />
                      ))}
                    />
                    <hr/>
                  </>
                )}
                {this.props.isNewCode && (
                  <div className="form-group d-flex">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">* </label>
                      <label>{t('l.desk.code')}</label>
                    </div>
                    <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                      <FieldControl
                        name="code"
                        render={TextInput}
                      />
                    </div>
                  </div>
                )}
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.supplier_ref_code')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="supplierDeskCode"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.iata')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="iataCode"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.location_type')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      strict={false}
                      name="deskLocationType"
                      render={(props) => (
                        <Select
                          value={deskLocationTypeOptions.find((select) => select.value === this.form.controls.deskLocationType.value)}
                          placeholder={t('ph.desk.location_type')}
                          options={(deskLocationTypeOptions)}
                          disableClear
                          disableMinWidth
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          label="desk location type"
                          onChange={(value) => this.patchField(value as SelectedOption, 'deskLocationType')}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.type')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      strict={false}
                      name="deskType"
                      render={(props) => (
                        <Select
                          value={deskTypeOptions.find((select) => select.value === this.form.controls.deskType.value)}
                          className="mr-1"
                          disableClear
                          disableMinWidth={true}
                          placeholder={t('ph.desk.desk_type')}
                          options={(deskTypeOptions)}
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          label="desk type"
                          onChange={(value) => this.patchField(value as SelectedOption, 'deskType')}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.walk_in')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start">
                    <FieldControl
                      strict={false}
                      name="isWalkInSupported"
                      render={(props) => <Checkbox {...props} id="isWalkInSupported" className="mt-1"
                                                   disabled={canEdit}></Checkbox>}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.meet_and_greet')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start">
                    <FieldControl
                      strict={false}
                      name="isMeetGreetSupported"
                      render={(props) => <Checkbox {...props} id="isMeetGreetSupported" className="mt-1"
                                                   disabled={canEdit}></Checkbox>}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.airport_tax')}</label>
                    <Tooltip
                      className="dark-tooltip"
                      modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                      placement="bottom"
                      target="airport-tax-tooltip"
                      autohide={false}
                    >
                        <pre className="dark-tooltip-text">
                          {t('comment.desk.airport_tax')}
                        </pre>
                    </Tooltip>
                    <img src={infoIcon} className="i-info-icon" id="airport-tax-tooltip"/>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="safRate"
                      render={NumberInput}
                    />
                  </div>
                </div>
                {this.props.isNewCode && (
                  <div className="form-group d-flex">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">* </label>
                      <label>{t('l.desk.desk_group')}</label>
                    </div>
                    <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                      <FieldControl
                        strict={false}
                        name="groupId"
                        render={(props) => (
                          <Select
                            defaultValue={this.getGroup()}
                            className="mr-1"
                            placeholder="Choose desk group"
                            disableMinWidth
                            options={this.getDeskGroupOptions()}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            label="group id"
                            onChange={(value) => this.patchField(value as SelectedOption, 'groupId')}
                          />
                        )}
                      />
                    </div>
                  </div>
                )}
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.pickup_instructions')}</label>
                  </div>
                  <div className="col-4 d-flex align-items-center justify-content-start edit-form-input wide-input">
                    <FieldControl
                      name="pickupInstructions"
                      render={InputTextArea}
                    />
                  </div>
                  <ExpandButton className="btn btn-text-only  ml-2" text="translations"
                                onClick={this.onPickupTranslationsClick}></ExpandButton>
                </div>
                {this.state.showPickupTranslations && (
                  <>
                    <FieldArray
                      strict={false}
                      name="pickupTranslations"
                      render={({ controls }: any) => controls.map((control: AbstractControl) => (
                        <FieldGroup
                          strict={false}
                          key={control.value.code}
                          control={control}
                          render={() => (
                            <div className="form-group d-flex">
                              <div className="col-4 d-flex align-items-center justify-content-end">
                                <label>{getLanguageName(control.value.language)}</label>
                              </div>
                              <div
                                className="col-4 d-flex align-items-center justify-content-start edit-form-input wide-input"
                                key={control.value.code}>
                                <FieldControl
                                  strict={false}
                                  name="translation"
                                  key={control.value.code}
                                  render={(props) => <InputTextArea {...props}
                                                                    id={control.value.code}></InputTextArea>}
                                />
                              </div>
                            </div>
                          )}
                        />
                      ))}
                    />
                    <hr/>
                  </>
                )}
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.return_instructions')}</label>
                  </div>
                  <div className="col-4 d-flex align-items-center justify-content-start edit-form-input wide-input">
                    <FieldControl
                      name="returnInstructions"
                      render={InputTextArea}
                    />
                  </div>
                  <ExpandButton className="btn btn-text-only  ml-2" text="translations"
                                onClick={this.onReturnTranslationsClick}></ExpandButton>
                </div>
                {this.state.showReturnTranslations && (
                  <>
                    <FieldArray
                      strict={false}
                      name="returnTranslations"
                      render={({ controls }: any) => controls.map((control: AbstractControl) => (
                        <FieldGroup
                          strict={false}
                          key={control.value.code}
                          control={control}
                          render={() => (
                            <div className="form-group d-flex">
                              <div className="col-4 d-flex align-items-center justify-content-end">
                                <label>{getLanguageName(control.value.language)}</label>
                              </div>
                              <div
                                className="col-4 d-flex align-items-center justify-content-start edit-form-input wide-input"
                                key={control.value.code}>
                                <FieldControl
                                  strict={false}
                                  name="translation"
                                  key={control.value.code}
                                  render={(props) => <InputTextArea {...props}
                                                                    id={control.value.code}></InputTextArea>}
                                />
                              </div>
                            </div>
                          )}
                        />
                      ))}
                    />
                    <hr/>
                  </>
                )}
                <SectionTitle title={t('section_title.address').toUpperCase()}/>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.address1')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="address1"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.address2')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="address2"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.address.city')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="city"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.address.postal_code')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="postalCode"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.address.state')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="state"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label className="mandatory-field">* </label>
                    <label>{t('l.desk.address.country')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="country"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group d-flex">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.address.lat_long')}</label>
                  </div>
                  <div className="col-3 d-flex justify-content-start edit-form-input">
                    <FieldControl
                      name="latitude"
                      options={{ updateOn: 'blur' }}
                      render={NumberInput}
                    />
                    <FieldControl
                      name="longitude"
                      options={{ updateOn: 'blur' }}
                      render={NumberInput}
                    />
                  </div>
                  <ExpandButton className="btn btn-text-only  ml-1"
                                text={t('b.show_on_map_Generic acton to show the location on map')}
                                onClick={this.onShowMapClick}></ExpandButton>
                </div>
                {this.state.showMap && (
                  <div className=" map-container ">
                    <GoogleMap
                      onSearch={(locationObject) => this.onLocationSearch(locationObject)}
                      isEdit={this.state.isEdit || this.props.isNewCode ? true : undefined}
                      location={this.form.controls.latitude.value && this.form.controls.longitude.value ? {
                        lat: this.form.controls.latitude.value,
                        lng: this.form.controls.longitude.value
                      } : undefined}
                      onLocationSelect={(lat: number, long: number) => this.onLocationSelect(lat, long)}
                    />
                  </div>
                )}
                <SectionTitle title={t('section_title.contact_info').toUpperCase()}/>
                <div className="form-group row">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.phone')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="phone"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.emegency_phone')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="emergencyPhone"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.email')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="email"
                      render={TextInput}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-4 d-flex align-items-center justify-content-end">
                    <label>{t('l.desk.fax')}</label>
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-start edit-form-input">
                    <FieldControl
                      name="fax"
                      render={TextInput}
                    />
                  </div>
                </div>
                <hr/>
                {showForm && (
                  <div className="row mt-2">
                    <div className="col-12 text-right">
                      <button type="button" className="btn btn-outline-secondary btn-lg mr-2" onClick={this.onCancel}>
                        {t('b.cancel_Generic cancel button translation').toUpperCase()}</button>
                      <button type="submit" className="btn btn-primary btn-lg" onClick={this.onSubmit}>
                        {t('b.save_Generic save button translation').toUpperCase()}</button>
                    </div>
                  </div>
                )}
              </form>
            )}
          />
        )}
        <ConfirmationModal
          title="Confirm desk removal"
          content="Are you sure you want to remove this desk?"
          isOpen={this.state.isDeleteModalOpen}
          toggle={() => this.setState({ isDeleteModalOpen: false })}
          onConfirm={() => this.onDeleteConfirm()}
          onCancel={() => this.setState({ isDeleteModalOpen: false })}
        />
        <DeskOpeningEditModal
          isOpen={this.state.isDeskOpeningModalOpen}
          toggle={() => this.setState({ isDeskOpeningModalOpen: false })}
          action={this.state.deskOpeningAction}
          deskOpening={this.state.selectedDeskOpening}
          onModalSubmit={(request: DeskOpeningRequest, action: DeskOpeningEditActions) => this.onDeskOpeningModalSubmit(request, action)}
        />
        <SelectModal
          isOpen={this.state.isEditDeskGroupModalOpen}
          toggle={() => this.setState({ isEditDeskGroupModalOpen: false })}
          options={this.getDeskGroupOptions()}
          selectedOptions={this.getGroup()}
          disableSelectClear
          selectLabel="Desk group:"
          title={t('ph.desk.desk_group')}
          warningTitle="You are about to move a desk to another desk group!"
          warningText="Be aware that another desk group may have different price rates, fees and settings applied"
          onSave={(value) => this.editDeskGroup(value)}
          showJumbotron
          optionName=""
        />
        <MandatoryItemSelectModal
          isOpen={this.state.isMandatoryItemModalOpen}
          toggle={() => this.setState({ isMandatoryItemModalOpen: false })}
          options={this.getItemOptions()}
          selectedOptions={this.form.controls.itemPrices.value}
          title={t('b.desk.edit_fees_button to open add/remove fees functionality')}
          onSave={(value) => this.editItemPrices(value)}
        />
        <DeskOpeningExceptionModal
          isOpen={this.state.isDeskOpeningExceptionModalOpen}
          toggle={() => this.setState({ isDeskOpeningExceptionModalOpen: false })}
          action={this.state.deskOpeningAction}
          deskOpeningException={this.state.selectedDeskOpeningException}
          onModalSubmit={(request: DeskOpeningExceptionRequest, action: DeskOpeningEditActions) => this.onDeskOpeningExceptionModalSubmit(request, action)}
        />
        <DuplicateDeskOpeningModal
          period={this.state.duplicatePeriod}
          isOpen={this.state.isDuplicateDeskOpeningModalOpen}
          toggle={() => this.setState({ isDuplicateDeskOpeningModalOpen: false })}
          type={this.state.duplicateType}
          onSave={(duration: {
            validFrom: string;
            validTo: string;
            type: DuplicateType
          }) => this.onDuplicate(duration)}
        />
        <SelectModal
          isOpen={this.state.isApplyFromModalOpen}
          toggle={() => this.setState({ isApplyFromModalOpen: false })}
          options={this.getDeskOptions()}
          showJumbotron
          selectedOptions={[]}
          selectLabel="Apply from:"
          title={`Apply another desks opening hours to (${desk ? desk.name : ''})`}
          onSave={(value) => this.applyOpeningsFromOtherDesk(value)}
          warningTitle="You are about to overwrite this desks opening hours!"
          warningText="Be aware that if you apply another desks opening hours to this desk, all the opening hours for this desk will be overwritten."
          optionName="desk"
        />
      </main>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  selectedDesk: state.setup.desks.selectedDesk,
  postSuccess: state.setup.desks.postSuccess,
  lastFetch: state.setup.desks.lastFetch,
  items: state.setup.items.items,
  oneWayFees: state.rates.oneWayFees.oneWayFees,
  deskGroups: state.setup.deskGroups.deskGroups,
  deskOpenings: state.setup.deskOpenings.deskOpenings,
  deskOpeningExceptions: state.setup.deskOpeningExceptions.deskOpeningExceptions,
  user: state.authentication.user,
  desks: state.setup.desks.desks,
  supplier: state.authentication.activeSupplier,
  carClasses: state.core.carClasses.acrissCodes
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<{}, {}, DeskActionTypes>
) => ({
  getSelectedDesk: (code: string) => dispatch(getDesk(code)),
  editDesk: (code: string, request: EditDeskRequest) => dispatch(editDesk(code, request)),
  addNewDesk: (request: DeskRequest) => dispatch(addNewDesk(request)),
  deleteDesk: (code: string) => dispatch(deleteDesk(code)),
  getItemList: () => dispatch(getItemList()),
  getOneWayFees: () => dispatch(getOneWayFeeList()),
  getDeskGroupList: () => dispatch(getDeskGroupList()),
  getDeskOpenings: (deskCode: string) => dispatch(getDeskOpeningList(deskCode)),
  deleteDeskOpening: (id: number, deskCode: string) => dispatch(deleteDeskOpening(id, deskCode)),
  editDeskOpening: (id: number, request: DeskOpeningRequest, deskCode: string) => dispatch(editDeskOpening(id, request, deskCode)),
  addDeskOpening: (request: DeskOpeningRequest, deskCode: string) => dispatch(addNewDeskOpening(request, deskCode)),
  getDeskOpeningExceptions: (deskCode: string) => dispatch(getDeskOpeningExceptionList(deskCode)),
  deleteDeskOpeningException: (id: number, deskCode: string) => dispatch(deleteDeskOpeningException(id, deskCode)),
  editDeskOpeningException: (id: number, request: DeskOpeningExceptionRequest, deskCode: string) => dispatch(editDeskOpeningException(id, request, deskCode)),
  addDeskOpeningException: (request: DeskOpeningExceptionRequest, deskCode: string) => dispatch(addNewDeskOpeningException(request, deskCode)),
  getDeskList: () => dispatch(getDeskList()),
  getAllCarClasses: () => dispatch(getAllCarClasses())
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(DeskDetails));
